import React, { FC, useContext } from "react";
import { defineMessages, IntlContext } from "react-intl";
import Svg from "@natera/material/lib/svg";
import checkIcon from "../../assets/svg/check.svg";
import "./statusPaid.scss";

const messages = defineMessages({
  statementStatusPaid: {
    id: "statementStatusPaid",
    defaultMessage: "Paid on {dateOfStatement}",
  },
});

interface StatusPaidProps {
  date: string;
}

const StatusPaid: FC<StatusPaidProps> = ({ date }) => {
  const intl = useContext(IntlContext);

  return (
    <div className="status-paid">
      <div className="icon">
        <Svg content={checkIcon} />
      </div>
      <div className="text">
        {intl.formatMessage(messages.statementStatusPaid, {
          dateOfStatement: date,
        })}
      </div>
    </div>
  );
};

export default StatusPaid;
